import { Component, OnInit,isDevMode } from '@angular/core';
import { Router } from '@angular/router';
import { AuthenticationService } from '../../services/authentication/authentication.service';
declare interface RouteInfo {
    path: string;
    title: string;
    icon: string;
    class: string;
}
export let ROUTES: RouteInfo[] = [

];

@Component({
    selector: 'app-sidebar',
    templateUrl: './sidebar.component.html',
    styleUrls: ['./sidebar.component.scss']
})
export class SidebarComponent implements OnInit {

    public menuItems: any[];
    public isCollapsed = true;

    constructor(
        private router: Router,
        private authenticationService: AuthenticationService
    ) { 
        if(this.authenticationService.usuario.perfil == 'admin'){
            ROUTES = [
                { path: '/dashboard', title: 'Tablero', icon: 'ni-tv-2 text-padrao', class: '' },
                { path: '/usuarios', title: 'Usuarios', icon: 'fas fa-users text-padrao', class: '' },
                { path: '/empresas', title: 'Empresas', icon: 'fas fa-building text-padrao', class: '' },
                { path: '/unidades', title: 'Unidades', icon: 'far fa-map text-padrao', class: '' },
                { path: '/leituras', title: 'Lecturas', icon: 'fas fa-mobile-alt text-padrao', class: '' }
            ];
        }
        else{
            ROUTES = [
                { path: '/empresa-dashboard/'+this.authenticationService.usuario.empresa, title: 'Tablero', icon: 'ni-tv-2 text-padrao', class: '' },
                { path: '/usuarios', title: 'Usuarios', icon: 'fas fa-users text-padrao', class: '' },
                { path: '/unidades', title: 'Unidades', icon: 'far fa-map text-padrao', class: '' },
                { path: '/leituras', title: 'Lecturas', icon: 'fas fa-mobile-alt text-padrao', class: '' }
            ];
        }

    }

    isDev(){
        return isDevMode();
    }

    ngOnInit() {
        this.menuItems = ROUTES.filter(menuItem => menuItem);
        this.router.events.subscribe((event) => {
            this.isCollapsed = true;
        });
    }
}
